interface Props<T extends string> {
    values: T[] | undefined;
    labels: Record<T, string>;
    pluralNoun: string;
}

export const EnumFilterLabel = <T extends string>({
    values,
    labels,
    pluralNoun,
}: Props<T>) => {
    if (!values || values.length === 0) {
        return null;
    }

    if (values.length === 1) {
        return <span>{labels[values[0]]}</span>;
    }

    return (
        <span>
            {values.length} {pluralNoun}
        </span>
    );
};
